// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Czaty',
  new_chat: 'Nowy czat',
  note: {
    team: 'Czaty wszystkich w {{restaurant}}: Twoje, Twojego zespołu i restauracji.',
    own: 'Twoje czaty w {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant: 'Twoje czaty bez wybranej restauracji. Czat trafia do czatów restauracji, gdy ją wybierzesz.',
  },
  log: 'Wszystkie zapytania w dzienniku Amigo',
  days: {
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    earlier: 'Wcześniej',
  },
  who: {
    you: 'Ty',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Właściciel',
      staff: 'Personel',
      partner: 'Partner',
    },
  },
  status: {
    done: 'Gotowe',
    answered: 'Odpowiedziano',
    waiting: 'Czeka na zatwierdzenie',
    partial: 'Zastosowano {{applied}} z {{total}}',
    rejected: 'Odrzucono',
    not_yet: 'Jeszcze niemożliwe',
    failed: 'Niepowodzenie',
  },
  none: {
    title: 'Brak czatów dla {{restaurant}}',
    title_no_restaurant: 'Brak czatów bez wybranej restauracji',
    text: 'Czaty rozpoczęte tutaj zostają tu, więc możesz do nich wrócić.',
  },
  loading: 'Wczytywanie czatów…',
  loading_more: 'Wczytywanie kolejnych czatów…',
  load_failed: 'Nie udało się wczytać czatów.',
  retry: 'Spróbuj ponownie',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nowa odpowiedź:',
  new_answers_few: 'Nowe odpowiedzi:',
  new_answers_many: 'Nowych odpowiedzi:',
  new_answers_other: 'Nowe odpowiedzi:',
};
